import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import { Acl } from 'modules/common/components/Acl';
import CreateSMSNotificationsModal from "../components/CreateSMSNotificationsModal";
import UpdateSMSNotificationsModal from "../components/UpdateSMSNotificationsModal";
import * as action from '../action';
import * as c from '../constant';

function SMSNotificationsContent({ showTransaction, isLoading, match, transactionInfo, permissions }) {
  const selectedTransaction = match.params.id;
  const setModal = useContext(ModalContext);

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const handleAddModal = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <CreateSMSNotificationsModal />,
      title: 'Create SMS Notification',
      modalSize: 'modal-md',
    });
  }

  const handleEditModal = e => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <UpdateSMSNotificationsModal updateList={transactionInfo.attributes} id={transactionInfo.id} />,
      title: 'Update SMS Notification',
      modalSize: 'modal-md',
    });
  }

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3">
            <div className="col-12 px-0 mt-0">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="py-1">
                  <div className="p-0 d-flex flex-nowrap w-100 justify-content-end">
                    <div className="d-flex justify-content-center">
                      {Acl(permissions, ['CREATE EMAIL SMS NOTIFICATION']) && (
                        <button
                          className="btn gen-btn font-weight-bold btn-primary cms-bg-color-primary cms-outline-primary "
                          onClick={handleAddModal}
                          type="button"
                        >
                          <i className="fas fa-plus" />&nbsp; Create New SMS
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 px-0 py-1">
              <div className="row">
                <div className="col-6">
                  <h2>
                    Information
                  </h2>
                </div>
                <div className="col-6 text-right">
                  {Acl(permissions, ['RESEND EMAIL SMS NOTIFICATION']) && (
                    <button
                      className="btn-blank"
                      type="button"
                      onClick={handleEditModal}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div
              className="col-12 border rounded border-primary p-3"
              style={{ height: '700px', overflowY: 'scroll' }}
            >
              <table className="table transaction-table table-borderless table-md">
                <tbody>
                  <tr>
                    <td className="text-dark">
                      Mobile Number
                    </td>
                  </tr>
                  <tr className="mb-2">
                    <td className="text-dark font-weight-bold">
                      {_.get(transactionInfo, "attributes.mobile_number") || "--"}
                    </td>
                  </tr>
                  <span className="d-block my-3" />
                  <tr>
                    <td className="text-dark">
                      Email Address
                    </td>
                  </tr>
                  <tr className="mb-2">
                    <td className="text-dark font-weight-bold">
                      {_.get(transactionInfo, "attributes.email") || "--"}
                    </td>
                  </tr>
                  <span className="d-block my-3" />
                  <tr>
                    <td className="text-dark">
                      Message
                    </td>
                  </tr>
                  <tr className="mb-2">
                    <td className="text-dark font-weight-bold">
                      {_.get(transactionInfo, "attributes.message") || "--"}
                    </td>
                  </tr>
                  <span className="d-block my-3" />
                  <tr>
                    <td className="text-dark">
                      Status
                    </td>
                  </tr>
                  <tr>
                    <td className="text-success font-weight-bold">
                      {_.get(transactionInfo, "attributes.status") || "--"}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

SMSNotificationsContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  isLoading: api.loading.indexOf(c.SHOW_TRANSACTION) > -1,
  permissions: getJson('permissions'),
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(SMSNotificationsContent);
